export default {"src":"/_next/static/media/gray_frame.7246cffa.svg","height":39,"width":98,"blurWidth":0,"blurHeight":0};